/**
 * @voltxampere/web — Locale signal (Sprint 11).
 *
 * Drives the i18n bundle lookup in `i18n/index.ts`. Persisted
 * to `localStorage` by `main.ts` on hydrate / mutation. Default
 * boot locale is Turkish to match the Şefim's primary language.
 *
 * Copyright © 2026 360 Studio
 * Proprietary — All rights reserved.
 */

import { signal } from "@preact/signals-core";

export type Locale = "tr" | "en";

export const SUPPORTED_LOCALES: readonly Locale[] = ["tr", "en"] as const;

export const currentLocale = signal<Locale>("tr");

/** Type guard for hydration: only accept known locales. */
export function isLocale(value: unknown): value is Locale {
  return value === "tr" || value === "en";
}

/** Toggle between TR and EN — used by the topbar locale chip. */
export function toggleLocale(): void {
  currentLocale.value = currentLocale.value === "tr" ? "en" : "tr";
}
